import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { StaticQuery, graphql } from 'gatsby';
import SideBar from './Sidebar'


const sections = [
  { id: 'top', name: 'Intro', icon: 'fa-home' },
  { id: 'portfolio', name: 'Portfolio', icon: 'fa-th' },
  { id: 'about', name: 'About Me', icon: 'fa-user' },
  { id: 'contact', name: 'Contact', icon: 'fa-envelope' },
];
class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPreloaded: true,
    };
  }

  componentDidMount() {
    this.timeoutId = setTimeout(() => {
      this.setState({ isPreloaded: false });
    }, 110);
  }

  componentWillUnmount() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  render() {
    const { children } = this.props;
    const { isPreloaded } = this.state;
    return (
      <StaticQuery
        query={graphql`
          query SiteTitleQuery {
            site {
              siteMetadata {
                title
                description
                keywords
              }
            } 
          }
        `}
        render={data => (
          <>
            <Helmet
              title={data.site.siteMetadata.title}
              meta={[
                { name: 'description', content: data.site.description },
                { name: 'keywords', content: data.site.siteMetadata.keywords },
              ]}
            >
              <html lang="en" />
              <link rel="prefetch" href="https://www.google.com" />
              <link rel="prefetch" href="https://www.google-analytics.com" />
              <link rel="prefetch" href="https://marketingplatform.google.com" />
              <link rel="prefetch" href="https://referrer.disqus.com" />
              <link rel="prefetch" href="https://disqusads.com" />
              <link rel="prefetch" href="https://c.disquscdn.com" />
              <link rel="prefetch" href="https://disqus.com" />
            </Helmet>
            <div className={isPreloaded ? 'main-body is-preload' : 'main-body'}>
            <SideBar sections={sections} />
            <main id="main">
              {children}
              </main>
            </div>
          </>
        )}
      />
    );
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
